<template>
	<div class="overflow-y-auto">
		<AppPagination
			:idsToHide="idsToHide"
			:useItemGetter="useDirectoryApp"
			noResultsMessage="No apps found"
			:getItemsAction="getAllDirectoryApps"
			:additionalFetchParams="additionalFetchParams"
		>
			<template #list-item="{ item }">
				<AllAppsMenuItem
					class="mb-4"
					:icon="item.icon"
					:name="item.service_name"
					:isSupported="isAppSupported(item)"
					@click.native="() => onClick(item)"
					:hasRequestedSupport="hasRequestedApp(item)"
					:isLoadingAppRequest="isLoadingAppRequest(item)"
				/>
			</template>
		</AppPagination>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import { useDirectoryApp } from '@/store/modules/apps/getters';
import { getAllDirectoryApps } from '@/store/modules/apps/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import AllAppsMenuItem from '@/components/SelectFavoriteApps/AllAppsMenuItem.vue';
import { allCalculatedDirectoryAppsIds, userRequestedAppIds } from '@/store/modules/auth/getters';

export default {
	name: 'AllAppsMenu',
	props: { searchString: { type: String }, currentSelectedApps: { type: Array } },
	components: { AllAppsMenuItem },
	computed: {
		...mapGettersShorthand({ useDirectoryApp, allCalculatedDirectoryAppsIds, userRequestedAppIds }),
		idsToHide() {
			return [...this.allCalculatedDirectoryAppsIds, ...this.currentSelectedApps.map(({ id }) => id)];
		},
		additionalFetchParams() {
			return { searchString: this.searchString };
		},
	},
	methods: {
		...mapActionsShorthand({ getAllDirectoryApps }),
		...mapActions(['requestFavoriteApp', 'deleteFavoriteAppRequest']),
		async onClick(app) {
			if (this.isAppSupported(app)) {
				this.$emit('select-app', app);
			} else {
				this.$set(this.loadingAppRequestIdsDict, app.id, true);
				try {
					if (this.hasRequestedApp(app)) {
						await this.deleteFavoriteAppRequest({ id: app.id });
					} else {
						await this.requestFavoriteApp({ id: app.id });
					}
				} catch {
					this.$toast.error('Integration request failed, please try again later');
				} finally {
					this.$set(this.loadingAppRequestIdsDict, app.id, false);
				}
			}
		},
		isAppSupported(app) {
			return app.related_services.length > 0;
		},
		hasRequestedApp(app) {
			return this.userRequestedAppIds.some((id) => id === app.id);
		},
		isLoadingAppRequest(app) {
			return this.loadingAppRequestIdsDict[app.id];
		},
	},
	data() {
		return { loadingAppRequestIdsDict: {} };
	},
};
</script>
